import React from "react";
import {Label, Table} from "@myob/myob-widgets";
import * as _ from "lodash";
import * as PropTypes from "prop-types";

function OpenBankingAccountResultTable({accountsData}) {
  const tableColumns = [
    {key: 'name', description: 'Account name', visible: true, align: 'left', valign: 'middle'},
    {
      key: 'number',
      description: 'Account number',
      visible: true,
      align: 'left',
      valign: 'middle'
    },
    {
      key: 'tag',
      description: '',
      visible: true,
      align: 'left',
      valign: 'middle'
    },
  ];

  const inactiveTypes =
    [
      {key: 'foreign_currency', description: 'Foreign currency account', tone: 'warning'},
      {key: 'closed_account', description: 'Closed account', tone: 'neutral'},
      {key: 'incomplete_account_details', description: 'Incompatible account', tone: 'neutral'},
    ];

  const getDescriptionLabel = (a) => {
    let reason = a.onboarded? 'onboarded' : a.unsupportedDescription
    let type = _.find(inactiveTypes, ['key', reason]);
    return type? (<Label tone={type.tone} type="boxed" size="sm" style={{whiteSpace: "nowrap"}} >
      {type.description}
    </Label>) : '';
  }

  accountsData = _.map(accountsData, account => {
    const tag = getDescriptionLabel(account);
    return {
      ...account,
      tag: tag
    }
  });

  return (
    <Table variant="bordered">
      <Table.Header>
        {tableColumns.map(column => (<Table.HeaderItem key={column.description}>{column.description}</Table.HeaderItem>))}
      </Table.Header>
      <Table.Body>{accountsData.map(account => (
        <Table.Row key={account.externalId}>
          {tableColumns.map(column =>
            (<Table.RowItem columnName={column.description} textWrap='wrap'>{account[column.key]}</Table.RowItem>))}
        </Table.Row>)
      )}
      </Table.Body>
    </Table>
  );
}

OpenBankingAccountResultTable.propTypes = {
  accountData: PropTypes.array
};
export default OpenBankingAccountResultTable;
